import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/product/importer/productImporterActions'

export default importerReducers(actions)
